import { gql } from '@apollo/client';
import React from 'react';
import {
  CoreCheckoutStartPaypalCheckoutRedirect,
  core_apimessages_Error as Error,
  core_apimessages_StartPaypalCheckoutRequest_PaymentMethodType as PayPalPaymentMethodType,
} from '../schemas/rql';
import Location from '../lib/wrapped_location';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { useEventTracker } from './trackPayPalEvent';
import { CheckoutPayPalButton } from './checkout/CheckoutPayPalButton';
import { useMutation } from '@reverbdotcom/commons/src/useMutation';

interface Props {
  currency: string;
  checkoutBundlingId: string;
  onError: (errors: Error[]) => void;
  parentComponentName: string;
  listingCurrency: string;
  quantity?: number;
}

export function CheckoutPayPalBuyNowButton({
  listingCurrency,
  parentComponentName,
  currency,
  quantity = null,
  checkoutBundlingId,
  onError,
}: Props) {
  const [startPaypalCheckout] = useMutation<
    CoreCheckoutStartPaypalCheckoutRedirect.Mutation,
    CoreCheckoutStartPaypalCheckoutRedirect.Variables
  >(
    START_PAYPAL_CHECKOUT_REDIRECT,
    {
      onError,
    },
  );
  const [loading, setLoading] = React.useState(false);

  const trackPaypalEvent = useEventTracker({ listingCurrency, parentComponentName, currency, quantity });

  async function createOrder() {
    setLoading(true);
    trackPaypalEvent(MParticleEventName.ClickedExpressPaypalButton);

    const result = await startPaypalCheckout({
      variables: {
        input: {
          checkoutBundlingId,
          paymentMethodType: PayPalPaymentMethodType.DC_VIA_PAYPAL,
          quantity,
        },
      },
    });

    if (result?.data?.startPaypalCheckout?.redirectUrl) {
      Location.replace(result.data.startPaypalCheckout.redirectUrl);
    } else {
      setLoading(false);
    }
  }

  return (
    <CheckoutPayPalButton
      onClick={createOrder}
      loading={loading}
    />
  );
}

const START_PAYPAL_CHECKOUT_REDIRECT = gql`
  mutation Core_Checkout_StartPaypalCheckout_Redirect(
    $input: Input_core_apimessages_StartPaypalCheckoutRequest
  ) {
    startPaypalCheckout(input: $input) {
      checkout {
        _id
      }
      redirectUrl
    }
  }
`;
